module.exports = __webpack_public_path__ + "static/img/logo-big.bb0b019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-big.png
// module id = Fgx8
// module chunks = 1